module.exports = __webpack_public_path__ + "dde9c61b5ab20a7405e1461912bc4fdb.otf";